// Copyright (c) 2016 Deere & Company

import RegistrationReview from '../../product/registration-review/state-connector';

export default {
    component: RegistrationReview,
    name: 'REGISTRATION_REVIEW',
    path: 'registrations'
};




// WEBPACK FOOTER //
// ./src/routes/products/registration-route.js